import React,{useState,useEffect} from "react";
import API from "../../utils/API";
import {AvField} from "availity-reactstrap-validation";

const CostUploadType = ({name,value,onChange,required,placeholder}) => {
    const [data,setData] = useState(null)

    useEffect(() => {
        API.get('/system/costuploadtypes').then((response) => {
            setData(response.data.data)
        });
    }, [])

    return (
        <select
            name={name}
            value={value}
            onChange={onChange}
            className="form-control"
        >
            {data &&
                data.map((dataItem, index) => (
                    <option key={index} selected={value === dataItem.id} value={dataItem.id}>{dataItem.title}</option>
                ))
            }
        </select>
    )
}

export default CostUploadType;
